// @needs-native-review — best-effort translation
import type { ChromeTranslations } from '../types';

export const pt: ChromeTranslations = {
  'nav.nextPage': 'página seguinte →',
  'nav.previousPage': '← página anterior',
  'nav.continueToLevel': 'continuar para o nível →',
  'nav.backToMenu': 'voltar ao menu →',
  'howto.page': 'página {n} de {total}',
  'options.title': 'Opções',
  'ui.language': 'Idioma',
};
